export default {"src":"/_next/static/media/icon_play_tungsten_brackets.90828895.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};